import {
    Button, Dialog,
    DialogContent,
    DialogTitle,
    Stack,
} from "@mui/material";
import React from "react";
import {useLocalize} from "crqlar-react-common/dist/utils/text.util";
import ReservationPreviewCard, {ReservationPreviewData} from "./floorPlan/v2/read/dialogs/ReservationPreviewCard";

interface Props {
    open: boolean
    onClose: () => void
    onConfirm: (period: 'breakfast' | 'lunch' | 'dinner' | 'breakfast-plus-dinner' | 'blank') => void
    draggedReservation?: ReservationPreviewData
}

const ReservationDayPeriodDialog = (props: Props) => {
    const {t} = useLocalize()

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {t("What kind of reservation do you want to create?")}
            </DialogTitle>

            <DialogContent>

                <Stack
                    spacing={2}
                    direction={'column'}
                >
                    {props.draggedReservation && (
                        <ReservationPreviewCard data={props.draggedReservation} />
                    )}

                    <Stack spacing={1} direction={'column'}>
                    <Button
                        variant={'contained'}
                        onClick={() => props.onConfirm('breakfast-plus-dinner')}
                    >
                        {t('Breakfast + dinner for the duration of stay')}
                    </Button>

                    <Button
                        variant={'outlined'}
                        onClick={() => props.onConfirm('breakfast')}
                    >
                        {t('Breakfast for the duration of stay')}
                    </Button>

                    <Button
                        variant={'outlined'}
                        onClick={() => props.onConfirm('lunch')}
                    >
                        {t('Lunch for the duration of stay')}
                    </Button>

                    <Button
                        variant={'outlined'}
                        onClick={() => props.onConfirm('dinner')}
                    >
                        {t('Dinner for the duration of stay')}
                    </Button>

                    <Button
                        variant={'outlined'}
                        onClick={() => props.onConfirm('blank')}
                    >
                        {t('Blank reservation')}
                    </Button>
                    </Stack>

                </Stack>

            </DialogContent>

        </Dialog>
    )
}

export default ReservationDayPeriodDialog
